<!-- services component -->
<script>
  import { listen } from "svelte/internal";
import { Col, Row, Container } from "sveltestrap";
  import CollapsibleSection from "../Components/CollapsibleSection.svelte"

  export let serviceData = {};
  const { heading, description, services_list,goto } = serviceData;

</script>

<!--START SERVICES-->
<section class="section pt-5 common-section" id="services">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">{heading}</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center pt-4 font-secondary">
          {description}
        </p>
      </Col>
    </Row>
    <Row class="mt-4">
      {#each services_list as list}
        <Col lg="4" class="mt-3">
          <div class="services-box text-center hover-effect">
            <i class="{list.icon} text-primary" />
            <h4 class="pt-3">{list.label}</h4>
            <p class="pt-3 text-muted">{list.text}</p>
            {#if list.goto !== undefined}
            <a href={list.goto} class="btn mdi">Read more</a>
            {/if}         
          </div>
        </Col>
      {/each}
    </Row>
  </Container>
</section>
<!--START SERVICES-->


<!--START INSPECTION-->
<section class="section bg-light" id="inspection">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">What a home inspection <u>is</u><br/> and what it is <u>not</u></h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          It is important to understand what is and is not included in a home inspection.  
          Below we will attempt to provide a high level overview, but if you have any questions about what will be included/excluded, please contact us.
        </p>   
      </Col>
    </Row>
    <Row class="mt-5">
      <Col lg="4">
        <div class="text-center process-box">
          <i class="pe-7s-check text-primary" />
          <h4 class="pt-3">Home inspections consist of<br>but are not limited to</h4>
          <p class="text-muted"></p>
          <ul class="list-unstyled text-muted">
            <li>Structural components</li>
            <li>Exterior components</li>
            <li>Roofing system components</li>
            <li>Plumbing system components</li>
            <li>Electrical system components</li>
            <li>Heating system components</li>
            <li>Cooling system components</li>
            <li>Interior components</li>
            <li>Household appliances (limited)</li>
            <li>Insulation components</li>
            <li>Fireplaces and solid fuel burning appliances</li>
          </ul>          
        </div>
      </Col>      
      <Col lg="4">
        <div class="text-center process-box">
          <i class="pe-7s-close text-primary" />
          <h4 class="pt-3">it is NOT a Building<br>or Occupancy Inspection</h4>
          <p class="text-muted">Because building codes vary from town to town, often dictated by region, home inspections are guided by a Standards of Practice covered in an administrative statute: N.J. Admin. Code § 13:40-15/16.</p>
        </div>
      </Col>
      <Col lg="4">
        <div class="text-center process-box">
          <i class="pe-7s-attention text-primary" />
          <h4 class="pt-3">Limitations</h4>
          <p class="text-muted">The home inspection may have limitations, as the inspector cannot inspect what is not able to be seen.  It is important during the buying process that the seller or occupant is reminded to allow the inspector access to all areas of the home, to be the best extent possible.</p>
          <CollapsibleSection>
            <p class="text-muted">Home inspectors may be required to describe certain types of materials as well as methods used to inspect the certain areas or components.  Home inspectors should not attempt to operate or inspect, an area or component they believe is unsafe to probe or inspect.  The home inspection report should list the component inspected, the condition it was found on the day of the inspection, implications of deficiencies, and recommendations to mitigate the damage, repair the component or area.</p>
          </CollapsibleSection>          
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!--END INSPECTION-->
